import { render } from "./market-graph.vue?vue&type=template&id=12e17e4c"
import script from "./market-graph.vue?vue&type=script&lang=js"
export * from "./market-graph.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__